import { Component, inject } from '@angular/core';
import { AlertsService } from '../../services/alerts.service';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-alerts',
    standalone: true,
    imports: [NgbAlertModule],
    templateUrl: './alerts.component.html',
    styleUrl: './alerts.component.scss',
})
export class AlertsComponent {

    protected readonly alertsService = inject(AlertsService);

}
